import { RETRY as s } from "../../constants/retry.js";
import { CustomError as p } from "../../errors/customError.js";
import c from "p-retry";
import * as r from "ramda";
let a = {};
const g = (t) => {
  a = r.mergeDeepRight(a, {
    [t]: {
      operating: !0
    }
  });
}, i = (t) => {
  a = r.mergeDeepRight(a, {
    [t]: {
      operating: !1
    }
  });
}, h = (t) => {
  const e = r.pathOr(0, [t, "retain"], a) + 1;
  a = r.mergeDeepRight(a, {
    [t]: { retain: e }
  });
}, l = (t) => {
  const e = r.pathOr(0, [t, "retain"], a) - 1;
  e <= 0 ? a = r.dissoc(t, a) : a = r.mergeDeepRight(a, {
    [t]: { retain: e }
  });
}, n = (t) => r.path([t, "data"], a), m = async (t) => (await c(() => {
  if (r.path([t, "operating"], a))
    throw new p(`fail to wait operation result: ${t}`);
}, s.WAIT_OPERATION), n(t)), f = async (t, e) => {
  g(t);
  const o = await e();
  return a = r.mergeDeepRight(a, {
    [t]: { data: o }
  }), i(t), o;
}, O = async (t, e) => {
  h(t);
  let o = null;
  try {
    r.path([t, "data"], a) ? o = n(t) : r.path([t, "operating"], a) ? o = await m(t) : o = await f(t, e);
  } catch {
    i(t);
  }
  return l(t), o;
};
export {
  O as singleOperation
};
//# sourceMappingURL=singleOperation.js.map
